'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSadOutline = function IoSadOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.7 22.2c0.2 0.7-0.2 1.3-0.9 1.5-0.2 0-0.5 0-0.8-0.1-0.4-0.2-0.7-0.4-0.8-0.8s-0.3-0.9-1-1.2-1.1 0-1.5 0.3c-0.3 0.2-0.8 0.2-1.2 0.1-0.2-0.1-0.5-0.3-0.7-0.5-0.5-0.6-0.2-1.3 0.4-1.7 1.2-0.7 2.3-1 3.8-0.5s2.3 1.6 2.7 2.9z m-15.8-2.4c0.6 0.4 0.8 1.1 0.3 1.7-0.2 0.2-0.5 0.4-0.7 0.5-0.4 0.1-0.9 0.1-1.2-0.1-0.4-0.3-0.8-0.5-1.5-0.3s-0.8 0.8-1 1.2-0.4 0.6-0.8 0.8c-0.3 0.1-0.6 0.2-0.8 0.1-0.7-0.2-1.1-0.8-0.9-1.5 0.4-1.3 1.1-2.4 2.7-2.9s2.7-0.2 3.9 0.5z m4.6-17.3c9.7 0 17.5 7.8 17.5 17.5s-7.8 17.5-17.5 17.5-17.5-7.8-17.5-17.5 7.8-17.5 17.5-17.5z m10.6 28.1c2.8-2.8 4.4-6.6 4.4-10.6s-1.6-7.8-4.4-10.6-6.6-4.4-10.6-4.4-7.8 1.6-10.6 4.4-4.4 6.6-4.4 10.6 1.6 7.8 4.4 10.6 6.6 4.4 10.6 4.4 7.8-1.6 10.6-4.4z m-3.3-2.6c0.4 0.6 0.2 1.4-0.3 1.8-0.3 0.1-0.5 0.2-0.7 0.2-0.4 0-0.8-0.2-1.1-0.5 0 0-1.4-2-5.2-2s-5.2 2-5.2 2c-0.3 0.3-0.7 0.5-1 0.5-0.3 0-0.5-0.1-0.8-0.2-0.5-0.4-0.7-1.2-0.3-1.8 0.1-0.1 2.2-3 7.3-3s7.2 2.9 7.3 3z' })
        )
    );
};

exports.default = IoSadOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/sad-outline.js
// module id = 2886
// module chunks = 168707334958949